import { render, staticRenderFns } from "./place-sugestion.vue?vue&type=template&id=aa97318e&scoped=true"
import script from "./place-sugestion.vue?vue&type=script&lang=js"
export * from "./place-sugestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa97318e",
  null
  
)

export default component.exports